<template>
  <div class="d-flex p-15">
    <div class="profile-info-2">
      <div class="table-card">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="table-responsive">
              <table class="table table-borderless">
                <thead>
                  <tr class="border-bottom">
                    <th class="StudY-table-head">STUDY</th>
                    <th class="StudY-table-head">SITE ID</th>
                    <th class="StudY-table-head">ROLE</th>
                    <th class="StudY-table-head">STATUS</th>
                    <th class="StudY-table-head text-center">LIVE DATA</th>
                    <th class="StudY-table-head text-center">TEST DATA</th>
                    <th class="StudY-table-head" v-if="!isProfile">BLINDED</th>
                    <th class="StudY-table-head" v-if="!isProfile">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id">
                    <td :title="item.studyName" v-if="item.studyName.length >= 19">{{ item.studyName.slice(0, 17) }}...</td>
                    <td v-else>{{ item.studyName }}</td>
                    <td>{{ item.userDefineSiteId }}</td>
                    <td v-if="userRole == 'Pi'">Principal Investigator</td>
                    <td v-if="userRole == 'SubPi'">Sub-Investigator</td>
                    <td v-if="userRole == 'StudyCoordinator'">
                      Study Coordinator
                    </td>
                    <td v-if="userRole == 'HomeHealth'">Home Health</td>
                    <td v-if="item.userRole == 'CallCenter'">Call Center</td>
                    <td v-if="userRole == 'Cra'">
                      Clinical Research Associate (Blinded)
                    </td>
                    <td v-if="userRole == 'CraUB'">
                      Clinical Research Associate (Unblinded)
                    </td>
                    <td v-if="userRole == 'Dm'">Data Manager</td>
                    <td v-if="userRole == 'Quality'">Quality</td>
                    <td v-if="userRole == 'SystemAdmin'">Platform Admin</td>
                    <td v-if="userRole == 'StudyAdmin'">Study Admin</td>
                    <td v-if="userRole == 'StudyManager'">Study Manager</td>
                    <td v-if="item.userRole == 'Rater'">Rater</td>
                    <td v-if="userRole == 'SiteDataLock'">Site-Data Lock</td>
                    <td v-if="userRole == 'Interviewer'">Interviewer</td>
                    <td v-if="userRole == 'Biostatistics'">Biostatistics</td>
                    <td v-if="userRole == 'Pharmacovigilance'">
                      Pharmacovigilance
                    </td>
                    <td>{{ item.status }}</td>
                    <td v-if="!item.canDataAccessChange" class="text-center">
                      <input type="checkbox" class="data-access-checkbox" onclick="return false" :checked="item.userDataAccessType == 'LIVE' || item.userDataAccessType == 'BOTH'" />
                    </td>
                    <td v-if="item.canDataAccessChange" class="text-center">
                      <input type="checkbox" class="data-access-checkbox live-checkbox" @click="dataAccessClick($event, item)" @change="dataAccessChange($event, item)" :checked="item.userDataAccessType == 'LIVE' || item.userDataAccessType == 'BOTH'" />
                    </td>
                    <td v-if="!item.canDataAccessChange" class="text-center">
                      <input type="checkbox" class="data-access-checkbox" onclick="return false" :checked="item.userDataAccessType == 'TEST' || item.userDataAccessType == 'BOTH'" />
                    </td>
                    <td v-if="item.canDataAccessChange" class="text-center">
                      <input type="checkbox" class="data-access-checkbox test-checkbox" @click="dataAccessClick($event, item)" @change="dataAccessChange($event, item)" :checked="item.userDataAccessType == 'TEST' || item.userDataAccessType == 'BOTH'" />
                    </td>
                    <td v-if="!isProfile">
                      <div class="blinded-container">
                        <span class="un-bld-Lbl-Txt">Unblinded</span>
                        <label class="switch">
                          <input type="checkbox" v-model="item.blinded" @change="changeStatus(item)" />
                          <div class="slider round"></div>
                        </label>
                        <span class="bld-Lbl-Txt">Blinded</span>
                        <span class="info-msg">
                          <i
                            class="fa fa-info-circle help_icon cursor_pointer"
                            aria-hidden="true"
                            data-toggle="popover"
                            tabindex="0"
                            data-trigger="focus"
                            data-content="Toggling the member as <b>Blinded</b> will hide sensitive participant
                                        information for this  member. <b>Unblinded</b> will show all participant information allowed
                                        for this role.
                                        "
                            data-html="true"
                          ></i>
                        </span>
                      </div>
                    </td>
                    <td v-if="!isProfile">
                      <span v-if="isSiteTeamUser">
                        <span class="Deactivate-from-site-study" v-if="item.status == 'Active'" @click="toggleSiteStatus(item)">
                          Deactivate from site
                        </span>
                        <span class="Activate-from-site-study" v-if="item.status == 'Inactive'" @click="toggleSiteStatus(item)">
                          Activate to site
                        </span>
                      </span>
                      <span v-if="!isSiteTeamUser">
                        <span v-if="item.status == 'Active'" class="Deactivate-from-site-study" @click="activeStudyStatus(item)">
                          Deactivate from study
                        </span>
                        <span v-if="item.status == 'Inactive'" class="Activate-from-site-study" @click="deactivStudyStatus(item)">
                          Activate to study
                        </span>
                      </span>
                    </td>
                  </tr>
                  <users-role-history-data :userRoleHistory="userRoleHistory" :isProfile="isProfile" :isSiteTeamUser="isSiteTeamUser" />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import $ from "jquery";
import "nprogress/nprogress.css";
import sortBy from "lodash/sortBy";
import { SYSTEM_ADMIN, STUDY_ADMIN, SUPPORT } from "@/constants/authRoles";
import UsersRoleHistoryData from "./users-role-history-data";

export default {
  name: "studySiteAssociation",
  props: ["data", "isSiteTeamUser", "userRole", "isProfile", "userRoleHistory"],
  components: {
    UsersRoleHistoryData
  },
  data() {
    return {
      list: [],
      userId: null,
      siteId: this.$route.params.siteId,
      studyId: this.$route.params.studyId
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSystemAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    }
  },
  mounted() {
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
    this.userId = this.$route.params.userId;
    this.list = sortBy(this.data, "studyName");
    this.canDataAccessChange();
  },
  methods: {
    toggleSiteStatus(item) {
      this.$emit("siteTeamStatusToggleChild", item);
    },
    activeStudyStatus(item) {
      this.$emit("studyTeamActiveStatusChild", item);
    },
    deactivStudyStatus(item) {
      this.$emit("studyTeamDeactiveStatusChild", item);
    },
    changeStatus(item) {
      const user = {
        studyId: item.studyId,
        userId: item.userId,
        siteId: item.siteId,
        blinded: item.blinded
      };
      this.$api.updateSiteUserBlindStatus(item.userId, item.studyId, item.siteId, item.blinded, user).then(
        () => {
          this.$toastr.success("Team member updated successfully.");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating team member.");
        }
      );
    },
    canDataAccessChange() {
      this.list.forEach(list => {
        list.canDataAccessChange = false;
        if (this.isProfile && !this.isSiteTeamUser) {
          list.canDataAccessChange = true;
        }
        if (this.canSystemAdminAccess || this.canStudyAdminAccess || this.canSupportAccess) {
          if (!this.isSiteTeamUser) {
            list.canDataAccessChange = true;
          }
        }
      });
    },
    dataAccessClick(e, item) {
      let clickedCheckbox;
      if (e.target.classList.contains("live-checkbox")) {
        clickedCheckbox = "Live";
      } else {
        clickedCheckbox = "Test";
      }

      if (clickedCheckbox == "Live") {
        if (item.userDataAccessType == "LIVE") {
          this.$toastr.error("Specifying data access rights is required.");
          e.preventDefault();
        }
      }
      if (clickedCheckbox == "Test") {
        if (item.userDataAccessType == "TEST") {
          this.$toastr.error("Specifying data access rights is required.");
          e.preventDefault();
        }
      }
    },
    dataAccessChange(e, item) {
      let clickedCheckbox;
      if (e.target.classList.contains("live-checkbox")) {
        clickedCheckbox = "Live";
      } else {
        clickedCheckbox = "Test";
      }

      if (item.userDataAccessType == "BOTH") {
        if (clickedCheckbox == "Test") {
          item.userDataAccessType = "LIVE";
        }
        if (clickedCheckbox == "Live") {
          item.userDataAccessType = "TEST";
        }
        this.$emit("dataAccessChangeChild", item);
        return;
      }

      if (clickedCheckbox == "Live") {
        if (item.userDataAccessType == "TEST") {
          item.userDataAccessType = "BOTH";
        }
      }

      if (clickedCheckbox == "Test") {
        if (item.userDataAccessType == "LIVE") {
          item.userDataAccessType = "BOTH";
        }
      }

      this.$emit("dataAccessChangeChild", item);
    }
  }
};
</script>

<style scoped lang="scss">
.users-bg {
  background: url("/static/img/bg/login_bg.png") no-repeat center center fixed;
  min-height: 100vh;
  background-color: #34537d;
  background-blend-mode: soft-light;
  height: 100%;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.profile-info-2 {
  width: 1108px;
  min-height: 96px;
  // margin: 17px 165px;
  padding: 28px 0px 25px 0px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
.table-card {
  color: #959fa4;
  margin-top: -28px;
}
.StudY-table-head {
  width: 32px;
  height: 12px;
  margin: 5px 112px 9px 31px;
  opacity: 0.5;
  font-family: Roboto-Regular;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 0px;
  left: 6px;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -14px;
  right: 1px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -14px;
  left: 10px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 13px;
  top: -14px;
}
.Deactivate-from-site-study {
  font-family: Roboto-Regular;
  color: #f16559;
  cursor: pointer;
}
.Activate-from-site-study {
  font-family: Roboto-Regular;
  color: #4c8ce4;
  cursor: pointer;
}
.activate-txt {
  font-family: Roboto-Regular;
  color: #1e8fe1;
}
.table-borderless > tbody > tr > td,
.table-borderless > tbody > tr > th,
.table-borderless > tfoot > tr > td,
.table-borderless > tfoot > tr > th,
.table-borderless > thead > tr > td,
.table-borderless > thead > tr > th {
  border: none !important;
}
.blinded-container {
  min-width: 100px;
}
.data-access-checkbox {
  width: 15px;
  height: 15px;
}
</style>
